
export interface RafFrame {
  id: number | null
}

export const getTransformStyle = (styles: any) => {
  return {
    WebkitTransform: styles,
    msTransform: styles,
    transform: styles,
  }
}

export const raf = {
  start: (callback: Function, delay: number) => {
    const now = Date.now()

    const timeout = () => {
      if (Date.now() - now >= delay) {
        callback()
      } else {
        stackframe.id = window.requestAnimationFrame(timeout)
      }
    }

    const stackframe: RafFrame = { id: window.requestAnimationFrame(timeout) }

    return stackframe
  },
  cancel: (id: number | null) => {
    if (id !== null) {
      window.cancelAnimationFrame(id)
    }
  }
}
